/**
 * xss-Filterung bei Input, TextArea und Primeng-Editor
 * MK 07.04.2025
 */
import {
    Directive,
    ElementRef,
    Renderer2,
    OnInit,
    AfterViewInit,
    OnDestroy,
    HostListener,
    Input
} from '@angular/core';
import DOMPurify from 'dompurify';

import { FormControl } from '@angular/forms';

@Directive({
    selector: '[sanitizeOnBlur]'
})
export class SanitizeOnBlurDirective implements OnInit, AfterViewInit, OnDestroy {

    @Input() editorControl?: FormControl;

    private isInputLike = false;
    private isPrimeEditor = false;
    private editorContentEl: HTMLElement | null = null;
    private editorBlurListener: (() => void) | null = null;

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngOnInit() {
        const nativeElement = this.el.nativeElement;
        if (nativeElement instanceof HTMLInputElement || nativeElement instanceof HTMLTextAreaElement) {
            this.isInputLike = true;
        } else if (nativeElement.tagName.toLowerCase() === 'p-editor') {
            this.isPrimeEditor = true;
        } else {
            console.warn(
                '[sanitizeOnBlur] should be used on input, textarea, or PrimeNG p-editor.'
            );
        }
    }

    ngAfterViewInit() {
        if (this.isPrimeEditor) {
            const nativeElement = this.el.nativeElement as HTMLElement;

            // Warte kurz auf das DOM (kann async erzeugt sein)
            setTimeout(() => {
                const editorContent = nativeElement.querySelector(
                    '.p-editor-container .p-editor-content > div[contenteditable="true"]'
                );
                if (editorContent) {
                    this.editorContentEl = editorContent as HTMLElement;
                    // Listener auf das blur-event (PrimeNG Editor)
                    this.editorBlurListener = this.renderer.listen(
                        this.editorContentEl,
                        'blur',
                        () => this.sanitizeEditorContent()
                    );
                } else {
                    console.warn('[sanitizeOnBlur] p-editor inner content not found.');
                }
            }, 0);
        }
    }

    ngOnDestroy() {
        if (this.editorBlurListener) {
            this.editorBlurListener();
        }
    }

    /**
     * Listener für Input-Form-Controls
     */
    @HostListener('blur')
    onNativeBlur() {
        if (this.isInputLike) {
            const nativeElement = this.el.nativeElement as HTMLInputElement | HTMLTextAreaElement;
            const clean = DOMPurify.sanitize(nativeElement.value, { RETURN_TRUSTED_TYPE: false });
            this.renderer.setProperty(nativeElement, 'value', clean);
        }
    }

    /**
     * Sanitizer-Methode für p-editor
     * @private
     */
    private sanitizeEditorContent() {
        if (this.editorContentEl) {
            const dirty = this.editorContentEl.innerHTML;
            const clean = DOMPurify.sanitize(dirty, { RETURN_TRUSTED_TYPE: false });
            this.renderer.setProperty(this.editorContentEl, 'innerHTML', clean);
            // Setze Angular-FormControl-Wert (ngModel aktualisieren)
            this.editorControl.setValue(clean);
        }
    }

}
